export const ServiceTableHeadCells = [
  { id: "id", label: "ID" },
  { id: "owner_id", label: "id" },
  { id: "name", label: "Namn" },
  { id: "cost", label: "Pris" },
  { id: "account", label: "Konto" },
  { id: "isActive", label: "Aktiv" },
];

export const ServiceDetailsTabs = [{ id: 1, label: "översikt" }];
